import React from 'react';
import { Dropdown, DropdownItem, DropdownList, Input } from '@cokitchen/cokitchen-components';
import { weightMeasurement } from 'utils/constants';
import './styles.scss';
import useDashboardContext from 'contexts/dashboard.context';
import { AddKitchenRequestType } from 'models/kitchen-request';
import MixSelect from 'pages/main-store/pricing/configuration/add-configuration/mix-dropdown';
import { MixIngredientItem } from 'models/kitchen-request';

const KitchenRequestForm = ({
  data,
  index,
  setValue,
  removeItem
}: {
  data: AddKitchenRequestType;
  index: number;
  setValue: (
    index: number,
    field: keyof AddKitchenRequestType,
    value: string | number | any[]
  ) => void;
  removeItem: (index: number) => void;
}) => {
  const { formStoreItems } = useDashboardContext();
  const getIngredient = (id: string) => formStoreItems?.find((ingredient) => ingredient.id === id);

  const handleMixSelection = (
    index: number,
    ingredient: any,
    mixItems: MixIngredientItem[],
    noOfPortions?: number
  ) => {
    setValue(index, 'ingredient_id', ingredient?.id ?? '');
    setValue(index, 'ingredient_name', ingredient?.name ?? '');
    setValue(index, 'items', mixItems ?? []);
    if (noOfPortions !== undefined) {
      setValue(index, 'no_of_portions', noOfPortions);
    }
  };

  const unitType = getIngredient(data?.ingredient_id)?.unit_type;

  return (
    <div className={`add__procurement pb-4 ${index > 0 ? 'pt-6' : ''} border-b border-[#EDEDEE]`}>
      <div>
        <div className='grid grid-cols-2 gap-6 mb-6 flex-wrap'>
          <div>
            <MixSelect
              index={index}
              ingredient_name={data?.ingredient_name}
              handleChange={(e, idx) => {
                const noOfPortions = e.rest?.no_of_portions;
                handleMixSelection(idx, e.rest, e.rest?.items ?? [], noOfPortions);
              }}
            />
          </div>
          <div className='relative'>
            <Input
              design='bordered'
              label='Quantity'
              placeholder='00'
              value={data.quantity}
              onChange={(e) => setValue(index, 'quantity', e.target.value)}
            />
            <div className='absolute w-[50px] h-[20px] z-10 rounded-[2px] shadow bottom-[20%] right-[5%]'>
              <Dropdown
                disabled
                content={
                  <div className='h-5 p-1 text-[11px] flex justify-between items-center gap-[2px] cursor-pointer measurement_dropdown'>
                    <span className='text-[#6F7376] truncate '>
                      {
                        <span className={`text-[#6F7376] truncate ${unitType ? 'capitalize' : ''}`}>
                          {unitType ?? 'Unit(s)'}
                        </span>
                      }
                    </span>
                    {/* <ArrowDownIcon className='w-5 h-5 text-[#96999C]' /> */}
                  </div>
                }>
                <DropdownList>
                  {weightMeasurement.map((item) => (
                    <DropdownItem
                      key={item.value}
                      onClick={() => {
                        return;
                      }}>
                      {item.name}
                    </DropdownItem>
                  ))}
                </DropdownList>
              </Dropdown>
            </div>
          </div>
        </div>
        {index >= 1 && (
          <button
            onClick={() => removeItem(index)}
            className='text-[#E60A2B] mt-2 font-medium text-sm '>
            - Remove Item
          </button>
        )}
      </div>
    </div>
  );
};

export default KitchenRequestForm;
